import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import BeratungSection from "@/components/BeratungSection";
import TM7Section from "@/components/TM7Section";
import ErlebniskochenSection from "@/components/ErlebniskochenSection";
import PreiseSection from "@/components/PreiseSection";
import AngeboteSection from "@/components/AngeboteSection";
import KurseSection from "@/components/KurseSection";
import KochkursTermineSection from "@/components/KochkursTermineSection";
import ProcessSection from "@/components/ProcessSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FaqSection from "@/components/FaqSection";
import KarriereSection from "@/components/KarriereSection";
import EinsteigerSection from "@/components/EinsteigerSection";
import ComebackSection from "@/components/ComebackSection";
import ContactSection from "@/components/ContactSection";
import StandorteSection from "@/components/StandorteSection";
import Footer from "@/components/Footer";

const HomePage = () => {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navigation />
      <main>
        {/* TEIL 1: Trust aufbauen */}
        <HeroSection />
        <AboutSection />
        <BeratungSection />

        {/* TEIL 2: Produkt & Erlebnis */}
        <TM7Section />
        <ErlebniskochenSection />

        {/* TEIL 3: Kommerziell */}
        <PreiseSection />
        <AngeboteSection />

        {/* TEIL 4: Vertrauen & nächste Schritte */}
        <ProcessSection />
        <KurseSection />
        <KochkursTermineSection />
        <TestimonialsSection />
        <FaqSection />

        {/* TEIL 5: Lokales SEO */}
        <StandorteSection />

        {/* TEIL 6: Karriere-Block (andere Zielgruppe) */}
        <KarriereSection />
        <EinsteigerSection />
        <ComebackSection />

        {/* TEIL 7: Abschluss */}
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
